export default __webpack_public_path__ + "static/media/opera.52d9eae1.svg";